<template>
  <div class="mx-3 alert-success" data-test-id="success">
    <SuccessItem
      v-for="(item, i) in storeSuccess"
      :key="i"
      :item="item"
      :index="i"
      :data-test-id="$tid('success', `store-success-${i}`)"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SuccessItem from '@/components/Success/SuccessItem.vue';
import { mapState } from 'pinia';
import { useSuccessStore } from '@/store/stores';
export default defineComponent({
  name: 'Success',
  components: { SuccessItem },
  computed: {
    ...mapState(useSuccessStore, ['storeSuccess']),
  },
});
</script>

<style scoped></style>
